import React, {Component} from 'react';
import classNames from 'classnames'
import './FJExport.less';

/**
 * @class FJExport
 * @description 视频输出组件
 * @property status {string} 输出分辨率
 */
class FJExport extends Component {

    render() {
        const {
            isShow,
            onRenderResolution,
            onRenderIntro,
            onRenderProgress,
            onRenderResult,
            onRenderGifOption,
            onRenderHeader,
        } = this.props;

        return (
            <div className={classNames('c-export-panel', isShow ? 'active' : '')}>
                {onRenderHeader()}
                <div className='c-export-body'>
                    {onRenderResolution()}
                    {onRenderIntro()}
                    {onRenderProgress()}
                    {onRenderResult()}
                    {onRenderGifOption()}
                </div>
            </div>
        );
    }
}

export default FJExport;
